import "./table-footer.scss";
import { IProps } from "./table-footer.types";

/**
 * Container for controls at the bottom of a table.
 * @param props.children Footer content.
 */
const TableFooter = ({ children }: IProps) => <div className="grid__table-footer">{children}</div>;

export default TableFooter;
